import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import UserService from "src/Services/API/user.service";
import WOService from "src/Services/API/wo.service";

const REFRESH_MS = 60 * 1000;

// Fire this after accepting or rejecting a job so the counts update now.
export const JOB_REQUESTS_REFRESH_EVENT = "job-requests-refresh";

/**
 * How many jobs are offered to this user and not answered yet (the Jobs
 * page's Requests tab, the tech app's Requests tab), for the red counts on
 * Jobs. Re-checked on page changes, every minute and when the tab regains
 * focus.
 */
function useJobRequestCount(enabled = true) {
  const location = useLocation();
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    const user = UserService.getCurrentUser();
    if (!enabled || !user) return;
    WOService.getAllWorkOrders(user.id, "", 0, { mine: "requested" }, null, 0, 1, 0)
      .then((response) => setCount(Number(response.data?.totalCount) || 0))
      .catch(() => {});
  }, [enabled]);

  useEffect(() => {
    refresh();
  }, [refresh, location.pathname, location.search]);

  useEffect(() => {
    const timer = setInterval(refresh, REFRESH_MS);
    const onVisible = () => {
      if (document.visibilityState === "visible") refresh();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener(JOB_REQUESTS_REFRESH_EVENT, refresh);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener(JOB_REQUESTS_REFRESH_EVENT, refresh);
    };
  }, [refresh]);

  return count;
}

export default useJobRequestCount;
